import { apiPath } from './appPaths';

export const normalizeBoardAssetFileBaseName = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

const buildBoardAssetFileBaseName = (board) => (
  normalizeBoardAssetFileBaseName(board?.slug)
  || normalizeBoardAssetFileBaseName(board?.name)
  || 'board'
);

const buildBoardSvgAssetFileName = (board, suffix = '') => {
  const normalizedSlug = normalizeBoardAssetFileBaseName(board?.slug);
  if (normalizedSlug) {
    return `${normalizedSlug}${suffix}.svg`;
  }

  const normalizedName = normalizeBoardAssetFileBaseName(board?.name);
  return `${normalizedName || 'board'}${suffix}.svg`;
};

export const buildBoardPinoutSvgFileName = (board) => {
  return buildBoardSvgAssetFileName(board);
};

export const hasBoardPublicPinoutPng = (board) => {
  const rawValue = board?.has_public_pinout_png ?? board?.hasPublicPinoutPng ?? false;
  if (typeof rawValue === 'boolean') {
    return rawValue;
  }

  const normalizedValue = String(rawValue ?? '').trim().toLowerCase();
  return normalizedValue === '1' || normalizedValue === 'true' || normalizedValue === 'yes';
};

export const buildBoardPinoutImageFileName = (board) => {
  const baseName = buildBoardAssetFileBaseName(board);

  return `${baseName}.${hasBoardPublicPinoutPng(board) ? 'png' : 'svg'}`;
};

export const buildBoardArtworkSvgFileName = (board) => buildBoardSvgAssetFileName(board, '-artwork');

export const buildBoardPinoutRasterImageFileName = (board) => (
  `${buildBoardAssetFileBaseName(board)}.${String(board?.public_pinout_image_format || '').toLowerCase() === 'png' ? 'png' : 'jpg'}`
);

const buildBoardAssetQuerySuffix = (board, variant = '') => {
  const updatedAt = String(board?.updated_at || '').trim();
  const querySegments = [];

  if (updatedAt) {
    querySegments.push(`v=${encodeURIComponent(updatedAt)}`);
  }

  if (variant) {
    querySegments.push(`variant=${encodeURIComponent(variant)}`);
  }

  return querySegments.length > 0
    ? `?${querySegments.join('&')}`
    : '';
};

const buildBoardSvgAssetSrc = (board, fileName, variant = '') => {
  const boardIdentifier = board?.id || board?.slug;
  if (!boardIdentifier) {
    return '';
  }

  const svgSrc = apiPath(
    `/boards/${encodeURIComponent(boardIdentifier)}/${encodeURIComponent(fileName)}`
  );

  return `${svgSrc}${buildBoardAssetQuerySuffix(board, variant)}`;
};

export const buildBoardSvgPreviewSrc = (board) => (
  buildBoardSvgAssetSrc(board, buildBoardPinoutSvgFileName(board), 'pinout')
);

export const buildBoardPinoutRasterPreviewSrc = (board) => {
  if (!hasBoardPublicPinoutPng(board)) {
    return '';
  }

  const boardIdentifier = board?.id || board?.slug;
  if (!boardIdentifier) {
    return '';
  }

  const rasterSrc = apiPath(
    `/boards/${encodeURIComponent(boardIdentifier)}/${encodeURIComponent(buildBoardPinoutRasterImageFileName(board))}`
  );

  return `${rasterSrc}${buildBoardAssetQuerySuffix(board, 'pinout')}`;
};

export const buildBoardArtworkSvgSrc = (board) => (
  buildBoardSvgAssetSrc(board, buildBoardArtworkSvgFileName(board), 'artwork')
);
